// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  error: null,
  logsList: [],
  total: 0,
  count: 0,
};

const slice = createSlice({
  name: 'logs',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload;
    },

    logsSuccess(state, action) {
      state.logsList = action.payload.data || [];
      state.total = action.payload.total || 0;
      state.count = action.payload.count || 0;
    },
  },
});

// Reducer
export default slice.reducer;
export const { hasError, logsSuccess } = slice.actions;

// ----------------------------------------------------------------------
// ✅ GET Login Logs
export function getLoginLogs(payload) {
  return async (dispatch) => {
    try {
      const params = new URLSearchParams();
      if (payload?.page) params.append('page', payload.page);
      if (payload?.per_page) params.append('per_page', payload.per_page);
      if (payload?.username) params.append('username', payload.username);
      if (payload?.action) params.append('action', payload.action);
      if (payload?.status) params.append('status', payload.status);
      if (payload?.start_date) params.append('start_date', payload.start_date);
      if (payload?.end_date) params.append('end_date', payload.end_date);
      
      const queryString = params.toString();
      const url = `/login-logs${queryString ? `?${queryString}` : ''}`;
      
      const response = await axios.get(url);
      if (response?.data) {
        dispatch(logsSuccess(response.data));
      }
      return response;
    } catch (error) {
      dispatch(hasError(error));
      throw error;
    }
  };
}


